var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeepResearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 29.3337H16M14.6667 8.33637C15.519 8.117 16.4125 8.00033 17.3333 8.00033C23.2244 8.00033 28 12.776 28 18.667C28 23.1435 25.2424 26.9759 21.3333 28.5583M7.33333 17.3337H12.6667C13.2862 17.3337 13.596 17.3337 13.8536 17.3849C14.9114 17.5953 15.7383 18.4222 15.9488 19.4801C16 19.7377 16 20.0475 16 20.667C16 21.2865 16 21.5963 15.9488 21.8539C15.7383 22.9117 14.9114 23.7387 13.8536 23.9491C13.596 24.0003 13.2862 24.0003 12.6667 24.0003H7.33333C6.71379 24.0003 6.40402 24.0003 6.14643 23.9491C5.08858 23.7387 4.26166 22.9117 4.05124 21.8539C4 21.5963 4 21.2865 4 20.667C4 20.0475 4 19.7377 4.05124 19.4801C4.26166 18.4222 5.08858 17.5953 6.14643 17.3849C6.40402 17.3337 6.71379 17.3337 7.33333 17.3337ZM5.33333 7.33366V17.3337H14.6667V7.33366C14.6667 4.75633 12.5773 2.66699 10 2.66699C7.42267 2.66699 5.33333 4.75633 5.33333 7.33366Z",
    stroke: "currentColor",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeepResearch);
export default __webpack_public_path__ + "static/media/deep-research.d57277c58f3d0ed85b5bdcfe37ddad9f.svg";
export { ForwardRef as ReactComponent };